import PropTypes from 'prop-types';
import React from 'react';

import {MenuItem} from '../menu/menu.jsx';

/** A deliberately small, additive editor affordance for the isolated Smart
 * School authoring session. The server, not this component, creates the .sb3
 * archive, proves project ownership, and sends it through Smart School asset
 * governance. */
class SmartSchoolSync extends React.Component {
    constructor (props) {
        super(props);
        this.state = {status: 'idle'};
        this.handleSync = this.handleSync.bind(this);
    }
    async handleSync () {
        if (!this.props.projectId || this.state.status === 'syncing') return;
        this.setState({status: 'syncing'});
        try {
            const path = `/api/integrations/smart-school/scratch-projects/${
                encodeURIComponent(this.props.projectId)
            }/sync`;
            const response = await fetch(path, {
                method: 'POST',
                credentials: 'same-origin'
            });
            if (!response.ok) {
                const error = new Error('sync failed');
                error.code = response.status === 409 ? 'reauthorize' : 'retry';
                throw error;
            }
            this.setState({status: 'complete'});
        } catch (error) {
            this.setState({status: error?.code === 'reauthorize' ? 'reauthorize' : 'failed'});
        }
    }
    render () {
        const labels = {
            syncing: 'Đang đồng bộ về Smart School…',
            complete: 'Đã gửi để kiểm tra an toàn trên Smart School',
            reauthorize: 'Quyền Smart School đã thay đổi — mở lại editor từ Smart School',
            failed: 'Chưa thể đồng bộ — thử lại',
            idle: 'Đồng bộ bản đã lưu về Smart School'
        };
        const label = labels[this.state.status];
        return <MenuItem onClick={this.handleSync}>{label}</MenuItem>;
    }
}

SmartSchoolSync.propTypes = {
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SmartSchoolSync;
